/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { useCheckout } from "../../providers";
import { TipModal } from "./TipModal";
//
export const CheckoutTipComponent = defineComponent({
  setup() {
    const checkout = useCheckout();
    const showTipModal = ref<boolean>(false);

    const handleTipConfirm = (amount: number | undefined) => {
      if (checkout.checkout.value) {
        if (amount && amount > 0) {
          checkout.checkout.value.tip = { value: amount };
        } else {
          checkout.checkout.value.tip = undefined;
        }
      }
    };
    //
    return () => (
      <>
        <button
          class="sm:w-full btn sm:btn-lg btn-secondary text-1xl lg:text-1xl font-semibold"
          onClick={() => (showTipModal.value = true)}
        >
          Tips
        </button>

        <TipModal
          isOpen={showTipModal.value}
          onClose={() => (showTipModal.value = false)}
          onConfirm={handleTipConfirm}
        />
      </>
    );
  },
});
